import { Alert, AlertTitle } from "@mui/material";
export default function Info(props) {
  const { title, content, severity } = props;
  return (
    <Alert severity={severity || "info"} style={{ borderRadius: "10px" }}>
      <AlertTitle>
        <span style={{ fontSize: "14px", fontWeight: "600" }}>{title}</span>
      </AlertTitle>
      <span style={{ fontSize: "12px", fontWeight: "500" }}>{content}</span>
    </Alert>
  );
}
